export default "__VITE_ASSET__5d47612f__"